/**
 * Запис блога: кнопка «Копіювати посилання» (.post-share-copy) копіює адресу запису
 * (data-url на .post-share) і на мить показує підказку над кнопкою.
 * Текст підказки приходить із PHP (wp_localize_script у Assets.php), тож перекладається разом з темою.
 */
const I18N = (typeof window !== 'undefined' && window.dykyiivanI18n) || {};
const TEXT = I18N.linkCopied || 'Посилання скопійовано';
const SHOW_MS = 1800;

async function copy(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (e) {
    // http / старі браузери
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    document.execCommand('copy');
    area.remove();
  }
}

export default function shareCopy() {
  document.querySelectorAll('.post-share').forEach((box) => {
    const btn = box.querySelector('.post-share-copy');
    if (!btn) return;

    const tip = document.createElement('span');
    tip.className = 'post-share-tip';
    tip.setAttribute('role', 'status');
    box.append(tip);

    let timer;
    btn.addEventListener('click', async () => {
      await copy(box.dataset.url || window.location.href);
      tip.textContent = TEXT; // зміна тексту в role="status" озвучується скрін-рідерами
      tip.classList.add('is-visible');
      clearTimeout(timer);
      timer = setTimeout(() => {
        tip.classList.remove('is-visible');
        tip.textContent = '';
      }, SHOW_MS);
    });
  });
}
